// extracted by mini-css-extract-plugin
export var post = "post-module--post--9Pjrq";
export var post__img = "post-module--post__img--2iQCf";
export var post__textbox = "post-module--post__textbox--3bA2w";
export var post__category = "post-module--post__category--21C88";
export var post__smalltext = "post-module--post__smalltext--1ZNw6";
export var post__date = "post-module--post__date--2qyFz";
export var post__newsbtn = "post-module--post__newsbtn--2nImT";